import { render, staticRenderFns } from "./_preAddMatchIBET.vue?vue&type=template&id=bb8fef86&scoped=true&lang=pug&"
import script from "./_preAddMatchIBET.vue?vue&type=script&lang=js&"
export * from "./_preAddMatchIBET.vue?vue&type=script&lang=js&"
import style0 from "./_preAddMatchIBET.vue?vue&type=style&index=0&id=bb8fef86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8fef86",
  null
  
)

export default component.exports